import { TopPageLinksTypes } from '@/components/TopPageLinks';
import { Paths } from '@/types/routes';
import HiringReportsComponent from './HiringReports.component';

const HiringReportsContainer = function (): JSX.Element {
  const reportsDashboardLink = {
    path: Paths.REPORTS,
  };

  const topPageLinks: TopPageLinksTypes = {
    pageLinks: [
      {
        label: 'Dashboard',
        to: reportsDashboardLink,
        isActived: true,
      },
    ],
    hideBackButton: true,
  };

  return <HiringReportsComponent topPageLinks={topPageLinks} />;
};

export default HiringReportsContainer;
